import React from "react";
import { Box, Button, HStack, SimpleGrid, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import RiskReviewStatusBadge from "../common/RiskReviewStatusBadge";
import { formatDate, getRequestId } from "../../utils/riskReviewFormatters";

const formatLabel = (value) => {
  if (!value) return "—";
  return String(value)
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const MetadataItem = ({ label, value }) => (
  <Box minW={0}>
    <Text color="gray.500" fontSize="xs" fontWeight="600">
      {label}
    </Text>
    <Text color="gray.800" fontSize="sm" fontWeight="600" noOfLines={1}>
      {value || "—"}
    </Text>
  </Box>
);

const RiskReviewRequestHeader = ({ request }) => {
  const muted = useColorModeValue("gray.600", "gray.400");
  const displayId = request?.sfdcOpportunityNo || getRequestId(request);
  const metadata = [
    { label: "Request Type", value: formatLabel(request?.requestType) },
    { label: "Revision", value: `Revision ${request?.revisionNo ?? 0}` },
    {
      label: "Template Version",
      value: request?.templateVersion ? `v${request.templateVersion}` : "—",
    },
    request?.createdAt ? { label: "Created", value: formatDate(request.createdAt) } : null,
    request?.updatedAt ? { label: "Updated", value: formatDate(request.updatedAt) } : null,
  ].filter(Boolean);

  return (
    <Box>
      <Button as={RouterLink} to="/risk-review/requests" size="sm" variant="ghost" leftIcon={<BsArrowLeft />} mb={3}>
        Back to Requests
      </Button>
      <VStack align="stretch" spacing={2.5}>
        <HStack justify="space-between" align="flex-start" wrap="wrap" spacing={3}>
          <Box minW={0}>
            <Text color={muted} fontSize="sm" fontWeight="700">
              Risk Review
            </Text>
            <HStack align="center" spacing={3} wrap="wrap" mt={0.5}>
              <Text color="gray.900" fontSize={{ base: "xl", md: "2xl" }} fontWeight="800" lineHeight="1.2">
                {displayId}
              </Text>
              <RiskReviewStatusBadge value={request?.status} />
            </HStack>
            {request?.projectName ? (
              <Text color={muted} mt={1} fontSize="sm">
                {request.projectName}
              </Text>
            ) : null}
          </Box>
        </HStack>
        <SimpleGrid
          columns={{ base: 2, md: 4, xl: 5 }}
          spacingX={8}
          spacingY={3}
          maxW="900px"
        >
          {metadata.map((item) => (
            <MetadataItem key={item.label} label={item.label} value={item.value} />
          ))}
        </SimpleGrid>
      </VStack>
    </Box>
  );
};

export default RiskReviewRequestHeader;
